import styled from "styled-components";

export const ButtonSpacer = styled.span`
  width: 32px;
`;
